import CityPageTemplate from "../city-template/CityPageTemplate";
import { sugarLandConfig } from "./data";

export default function SugarLandPage() {
  return <CityPageTemplate config={sugarLandConfig} />;
}